const getStringSortValue = function getStringSortValue(str) {
  let sortValue = str.toString().split('').reduce((p, c) => (p + parseInt(c.charCodeAt(0), 10)), 0);
  let boost = 1;
  if (isNaN(str) === false) {
    boost = 1 / 1000 / 1000 / 1000 / 1000;
    sortValue *= parseInt(str, 10);
  }
  return sortValue * boost;
};

export default {
  getStringSortValue,
};



// WEBPACK FOOTER //
// ./src/utils/sort.js